<template>
  <div class="commerceView">
    <div class="circulateT titleBox">
        <img class="title" src="./img/title.png" alt="">
    </div>
    <div class="circulate">
        <img class="image" src="./img/icon.png" alt="">
    </div>
    <div class="circulateB circulateTitle">
        <img class="image" src="./img/commerceA.png" alt="">
    </div>
    <div class="circulateB circulateTitle">
        <img class="image" src="./img/commerceB.png" alt="">
    </div>
    <div class="circulateB circulateTitle">
        <img class="image" src="./img/commerceC.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'commerceView'
}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.circulateT{
    width: 750px/$md;
    height: 300px/$md;
    .title{
        width: 100%;
        // width: 1252px/$md;
        // height: 300px/$md;
        // transform: translate(-30%);
    }
}
.titleBox{
    width: 750px/$md;
    height: 300px/$md;
    overflow: hidden;
}
.circulateTitle{
   padding-left: 22px/$md;
   padding-right: 22px/$md;
}
.circulate{
    width: 250px/$md;
    height: 107px/$md;
    margin: 50px/$md auto;
}
.circulateB{
    margin-bottom: 50px/$md;
}
.image{
    width:100%;
    height: 100%;
}
</style>
